(window.ProductList = function (Behaviors) {

  "use strict";
  
  function ProductList(elem) {
    Behaviors.init(ProductList, this, arguments)

    this.instaSlider = this.$elem[0];

    if (window.innerWidth < 768) {
      const ProductList = new Swiper(this.instaSlider, {
        wrapperClass: 'product__list',
        slideClass: 'fp__item',
        speed: 500,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
            loop: false,
          }
        }
      });
    }
  }

  Behaviors.inherit(ProductList, Behaviors.Behavior);
  ProductList.QUERY = '.s-product-list__container';

  Behaviors.register_behavior(ProductList);
  
  return ProductList;

  }(window.Behaviors));